module.exports = "varying vec4 v_color;\r\nvoid main()\r\n{\r\n    gl_FragColor = v_color;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/default.fs.glsl
// module id = 4
// module chunks = 0